import * as React from 'react'
import { Text, TextProps, useTheme } from '../index'

export interface IconProps extends TextProps {
  src: string
  as?: string
}

/** A customized icon component */
export const Icon: React.FC<IconProps> = (props: IconProps) => {
  const theme = useTheme()
  const { src, ...rest } = props

  return (
    <Text
      lineHeight={1}
      textAlign="center"
      fontStyle="normal"
      fontFamily={
        src.indexOf('/') > -1 ? src.split('/')[0] : Object.keys(theme.icons)[0]
      }
      {...rest}
    >
      {src.indexOf('/') > -1
        ? theme.icons[src.split('/')[0]][src.split('/')[1]]
        : theme.icons[Object.keys(theme.icons)[0]][src]}
    </Text>
  )
}

Icon.defaultProps = {
  px: [0, 1],
  src: 'down-open',
  itemType: 'Icon'
}

export default Icon
